"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixTextIt = fixTextIt;
const tex_syntax_1 = require("./tex-syntax");
function fixTextIt(tex) {
    return tex.replace(new RegExp(`\\\\textit\\s*(${(0, tex_syntax_1.block)(4)})`, "g"), "\\text{\\it$1}");
}
